<template>
<div class="chapter">
<div class="inner_page">
<p class="dedication">To my father, the only creator <br/>to whose existence and minor miracles <br/>I can testify</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// AlfaRomeo_00000.vue?2c7afc80